/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useRef, useState } from 'react'

import Vtabs from '../../../components/tabs/vtabs'
import Categories from './categories/categories'
import FormTooltip from './form-tooltip/form-tooltip'
import Rank from './rank/rank'
import RNLTD from './rnltd/rnltd'
import SubCategories from './subcategories/subcategories'
import UserProfiles from './userprofiles/userprofiles'

const MetadataManagement = ({setActiveTab} : any) => {
  const [tableItems, setTableItems] = useState([
    {
      content: (
        <Categories />
      ),
      icon: 'icon-category1 circled-icon font-13 me-1',
      isActive: 'true',
      tabID: 0,
      tabTitle: 'Categories',

    },
    {
      content: (
        <SubCategories />
      ),
      icon: 'icon-category1 circled-icon font-13 me-1',
      isActive: 'flase',
      tabID: 1,
      tabTitle: 'SubCategories',

    },
    {
      content: (
        <Rank />
      ),
      icon: 'icon-category1 circled-icon font-13 me-1',
      isActive: 'false',
      tabID: 2,
      tabTitle: 'Rank',
    },
    {
      content: (
        <RNLTD />
      ),
      icon: 'icon-category1 circled-icon font-13 me-1',
      isActive: 'false',
      tabID: 3,
      tabTitle: 'RNLTD',
    },
    {
      content: (
        <UserProfiles />
      ),
      icon: 'icon-adduser circled-icon font-13 me-1',
      isActive: 'false',
      tabID: 4,
      tabTitle: 'User Profiles',
    },
    {
      content: (
        <FormTooltip />
      ),
      icon: 'icon-info circled-icon font-13 me-1',
      isActive: 'false',
      tabID: 5,
      tabTitle: 'Form Tooltips',
    },
  ])
  const tabsMinHeight = (tableItems.length) * 55

  const [tabsContentHeight, setTabsContentHeight] = useState<number>(0)
  window.addEventListener('resize', handleWindowResize)
  useEffect(() => {
    // Get header height based on attribute or tag
    handleWindowResize()
  }, [])
  function handleWindowResize() {
    // const tabsminheight: any = (tableItems.length) * 55
    setTabsContentHeight(tabsMinHeight)
  }
  useEffect(() => {
    // Update CSS variable when headerHeight changes
    document.documentElement.style.setProperty('--tabsconentmin-height', `${tabsContentHeight}px`)
  }, [tabsContentHeight])

  const handleTabSelect = (index) => {
    setActiveTab(index)
  }

  useEffect(() =>{
    ([
      {
        content: (
          <Categories />
        ),
        icon: 'icon-category1 circled-icon font-13 me-1',
        isActive: 'true',
        tabID: 0,
        tabTitle: 'Categories',
  
      },
      {
        content: (
          <SubCategories />
        ),
        icon: 'icon-category1 circled-icon font-13 me-1',
        isActive: 'flase',
        tabID: 1,
        tabTitle: 'SubCategories',
  
      },
      {
        content: (
          <Rank />
        ),
        icon: 'icon-category1 circled-icon font-13 me-1',
        isActive: 'false',
        tabID: 2,
        tabTitle: 'Rank',
      },
      {
        content: (
          <RNLTD />
        ),
        icon: 'icon-category1 circled-icon font-13 me-1',
        isActive: 'false',
        tabID: 3,
        tabTitle: 'RNLTD',
      },
      {
        content: (
          <UserProfiles />
        ),
        icon: 'icon-adduser circled-icon font-13 me-1',
        isActive: 'false',
        tabID: 4,
        tabTitle: 'User Profiles',
      },
      {
        content: (
          <FormTooltip />
        ),
        icon: 'icon-info circled-icon font-13 me-1',
        isActive: 'false',
        tabID: 5,
        tabTitle: 'Form Tooltips',
      },
    ])
  }, [])

  return (
    <div className='container'>
      <div className='row'>
        <div
          className='shadow card mt-0 p-0 tabscontent-height'
          style={{ minHeight: tabsMinHeight + 16 }}
        >
          <Vtabs
            anchorclass='title-color20 font-14 poppins-semibold text-capitalize'
            className='w-100 h-100'
            items={tableItems}
            mainTabsclass='card-body v-tabs'
            onTabSelected={handleTabSelect}
            tablistclassName='w-100'
            vtabscontentclassName='w-100 border-left4 ps-lg-4 tabscontntinheight'
          />
        </div>
      </div>
    </div>
  )
}
export default MetadataManagement
